import { render, staticRenderFns } from "./ModattaTeam.vue?vue&type=template&id=5ba48846"
import script from "./ModattaTeam.vue?vue&type=script&lang=js"
export * from "./ModattaTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports